import React from 'react';
import MeetingLayersList from './meeting_layers_list';
import MeetingLabelsList from './meeting_labels_list';
import Selectable from '../common/selectable';

export default function LayersMenu(props) {
  return (
    <Selectable
      selectedClass="abl-selected"
      id="layers"
      selected={props.selected}
      clickTargetClassName="abl-layers-menu-title"
      onChange={props.onMenuItemChange}>
      <div 
        className="abl-layers-menu" 
        onMouseDown={props.onMouseDown} 
        onClick={props.onClick}>
        <h4 className="abl-layers-menu-title">
          <span>Layers</span>
        </h4>
        <div className="abl-tray">
          <div className="abl-layers-group">
            <h5>Highlights</h5>
            <MeetingLayersList 
              items={props.highlights} 
              onChange={props.onLayerChange}
            />
          </div>
          <div className="abl-layers-group">
            <h5>Labels</h5>
            <MeetingLabelsList 
              items={props.labels}
              onChange={props.onLabelChange}
            />
          </div>
        </div>
      </div>
    </Selectable>
  );
};


/** WEBPACK FOOTER **
 ** ./src/js/components/schedule/layers_menu.js
 **/